var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 32 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 58,
    height: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "59,27 63,27 63,39 59,39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 50,
    height: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "22,33 29,30 29,36 36,33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.0c0d1c1a91835f9513a2b4dbb37886d1.svg";
export { ForwardRef as ReactComponent };